module.exports = __webpack_public_path__ + "img/newsLogo5.8ced9357.png";